import React from 'react';
import { useLanguage } from '../../lib/LanguageContext';
import LegalLinks from './LegalLinks';

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-ink-900 text-cream/80 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5">
          <div className="mb-4 bg-cream/95 rounded-sm inline-block p-3">
            <img
              src="/logo.png"
              alt="Casa Serena"
              className="h-20 w-auto"
              loading="lazy"
            />
          </div>
          <p className="text-sm text-cream/60 max-w-md leading-relaxed">{t.footer.tagline}</p>
        </div>
        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-3">Contact</div>
          <div className="text-sm text-cream/80 leading-relaxed">
            <a href="mailto:info@casaserena.es" className="hover:text-cream transition-colors">info@casaserena.es</a><br />
            <a href="tel:+31643875097" className="hover:text-cream transition-colors">+31 6 4387 5097</a><br />
            Costa Blanca · Alicante · Spain
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-3">Legal</div>
          <p className="text-xs text-cream/60 leading-relaxed mb-4">{t.footer.legalNote}</p>
          <LegalLinks />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 mt-12 pt-6 border-t border-cream/10 text-xs text-cream/40">
        © {year} Casa Serena · {t.footer.rights}
      </div>
    </footer>
  );
};

export default Footer;
